import { useState } from "react";
import { Menu, X } from "lucide-react";
import { BuyButton } from "./BuyButton";

const LINKS = [
  { href: "#inside", label: "What's Inside" },
  { href: "#value", label: "The Value" },
  { href: "#who", label: "Who It's For" },
  { href: "#catherine", label: "About Catherine" },
  { href: "#faq", label: "FAQ" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-navy/10 bg-white/70 backdrop-blur-xl" data-testid="site-header">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 lg:px-10">
        <a href="#top" className="flex items-center" data-testid="nav-logo-link" aria-label="Civility Partners home">
          <img src="/civility-partners-logo.png" alt="Civility Partners" className="h-10 w-auto" />
        </a>
        <nav className="hidden items-center gap-8 lg:flex" aria-label="Primary">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className="text-sm font-medium text-navy/70 transition-colors duration-200 hover:text-terra"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <div className="hidden lg:block">
          <BuyButton testId="nav-buy-button" size="sm">Get the Toolkit — $249</BuyButton>
        </div>
        <button
          className="lg:hidden"
          onClick={() => setOpen(!open)}
          data-testid="nav-menu-toggle"
          aria-label={open ? "Close menu" : "Open menu"}
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>
      {open && (
        <nav className="border-t border-navy/10 bg-cream px-6 py-4 lg:hidden" aria-label="Mobile">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              data-testid={`nav-mobile-link-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className="block py-3 text-base font-medium text-navy/80"
            >
              {l.label}
            </a>
          ))}
          <BuyButton testId="nav-mobile-buy-button" className="mt-3 w-full">Get the Toolkit — $249</BuyButton>
        </nav>
      )}
    </header>
  );
};
